/**
 * Created by Zac on 18/03/2016.
 */


// https://coderwall.com/p/uf2pka/normalize-twitter-bootstrap-carousel-slide-heights
// This means that carousels don't change height when the content in them is different heigths


function carouselNormalization() {
  const carousels = $('.js__slider'); // / This is only a problem on children as slider

  $.each(carousels, function () {
    let items = $(this).find('.item'), // grab all slides
      heights = [], // create empty array to store height values
      widths = [],
      widest,
      tallest; // create variable to make note of the tallest slide

    if (items.length > 0) {
      function normalizeSize() {
        // if (DEBUGGIN) console.group('slider');

        items.each(function () { // add heights to array
          heights.push($(this).height());
          widths.push($(this).width());
        });

        tallest = Math.max.apply(null, heights); // cache largest value
        widest = Math.max.apply(null, widths);
        // if (DEBUGGING) {
        //     console.log("Tallest slide is", tallest, 'widest carousel is', widest);
        // }
        items.css('min-height', `${tallest}px`);
        items.css('min-width', `${widest}px`);
      }

      normalizeSize();
      $(window).on('load resize orientationchange shown.bs.tab	shown.bs.collapse changeScene jwplayerReady', function () {
        tallest = 0, heights = []; // reset vars
        widest = 0, widths = [];
        items.each(function () {
          $(this).css('min-height', '0'); // reset min-height
          $(this).css('min-width', '0'); // reset min-height
        });
        normalizeSize(); // run it again
      });
    }
  });
}

// We use this pattern to wait until the store has been initialised
let curSlidersState;
function setupReduxSlider() {
  if (typeof (store) !== 'undefined') {
    function select(state) {
      return state.api.sliders;
    }
    function handleSliderChange() {
      const previousValue = curSlidersState;
      curSlidersState = select(window.store.getState());

      // if (previousValue !== curSlidersState) {
      //     // window.loDebug('Showing all the slider navs');
      //     // $('.js__slider__control').show;
      // }
    }

    store.subscribe(handleSliderChange);
  } else {
    setTimeout(setupReduxSlider, 200);
  }
}

setupReduxSlider();


$(document).ready(function () {

   if($('.js__slider').length>0){
       $('.js__slider').carousel({
           interval: false,
           wrap: false,
       });
   }

  let curActivities = [];

  function slideProcessor(nextSlide) {
    const activityInteractions = nextSlide.find('.isActivity').find('ul, .btn-group, .feedback-button');
    if (activityInteractions.length > 0) {
      $('.js__slider__control-right').hide();
      $('.js__slider__control-right').addClass('hidden');

      curActivities = [];
      $.each(activityInteractions, function () {
        curActivities.push($(this).attr('data-id'));
        if (DEBUGGING) console.log('added', $(this).attr('data-id'));
      });

      activityInteractions.click(function (event) {
        curActivities.splice(curActivities.indexOf($(this).attr('data-id')), 1);
        // console.log(curActivities.indexOf($(this).attr('id')));
        $(this).unbind(event);
        const isLast = nextSlide.hasClass('js__slider__slide--last');
        if (curActivities.length == 0 && !isLast) {
          $('.js__slider__control-right').show();
          $('.js__slider__control-right').removeClass('hidden');
        }
      });
    } else {
      $('.js__slider__control').show();
      $('.js__slider__control').removeClass('hidden');
    }
  }

  // hide back button of slider
  const controlleft = $('.carousel-control.left');
  controlleft.hide();

  $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    carouselNormalization();
  });

  $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
    carouselNormalization();
  });

  // $('.carousel').carousel();
  // $('.carousel').bind('slide', function(e) {
  //     $(this).animate({height: $(e.relatedTarget).outerHeight()});
  // });


  $('.childrenAsSlider').each(function () {
    const slider = $(this);
    const time = slider.data('fade-time');

    if (time != 0) {
      const item = $(this).find('.js__slider__slide');

      // The remaining styling is added by the CSS class glasshouse-carousel-fade
      item.css('transition-duration', `${time}ms`);
    }
  });

  $('.myCarousel-target').on('click', function () {
    // console.log('going to '+$(this).attr('data-slide-to'));
    // console.log('data target: '+$(this).attr('data-target'));
    const thisCache = $(this);
    $(thisCache.attr('data-target')).carousel(parseInt(thisCache.attr('data-slide-to').replace('slide', '')) - 1);
    $('.myCarousel-target.active', thisCache.attr('data-target')).removeClass('active');
    thisCache.addClass('active');
    $(thisCache.attr('data-target')).carousel();
    // stop the auto sliding madness
    $('.carousel').each(function () {
      const temp = $(this);
      temp.carousel({
        interval: false,
        keyboard: true,
        wrap: false,
      });
    });
  });

  // Hooks onto all sliders
  $('.js__slider').each(function () {
    // Triggered before the slide has changed
    $(this).on('slide.bs.carousel', function (e) {
      // / This pauses any video playing inside the previous slide
      const slideFrom = $(this).find('.active.js-slide').first();
      const players = slideFrom.find('.jwplayer');
      const videoPlayerIDs = players.map(player => $(players[player]).attr('id'));
      for (let i = 0; i < videoPlayerIDs.length; i++) {
        jwplayer(videoPlayerIDs[i]).stop();
      }
    });
    $(this).on('slid.bs.carousel', function (event) {
      // var nextSlide = $(this).find('.sp-slide[data-index="' + event.index + '"]').first();
      store.dispatch(actions.setSlide({
        sliderId: $(this).attr('id'),
        slideId: $(event.relatedTarget).attr('id'),
      }));
    });


    if ($(this).attr('data-restrictChange') == true) {
      $(this).on('slid.bs.carousel', (event) => {
        // var nextSlide = $(this).find('.sp-slide[data-index="' + event.index + '"]').first();
        slideProcessor($(event.relatedTarget));
      });

      $(document).on('changeScene', (event) => {
        const nextSlide = $(`.scene.${event.message} .js__slider__slide`).first();
        slideProcessor(nextSlide);
      });
    }
  });


  // carousel slid hide carousel control button in order to stop looping carousel
  $('.js__slider').on('slid.bs.carousel', function () {
    // $(this).height('auto');
    if ($(this).find('.carousel-inner').find('.js__slider__slide:last').first().hasClass('active')) {
      // alert('last');
      $(this).children('.js__slider__control-right').hide();
      $(this).children('.js__slider__control-left').show();
    } else if ($(this).find('.carousel-inner').find('.js__slider__slide:first').first().hasClass('active')) {
      $(this).children('.js__slider__control-left').hide();
      $(this).children('.js__slider__control-right').show();
    } else {
      $(this).children('.js__slider__control-left').show();
      $(this).children('.js__slider__control-right').show();
    }
  });


  // THis allows for a
  $('.js__slider').keydown((e) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      $(e.target).click();
    }
  });


  // $(document).keydown((e) => {
  //     console.log('here');
  //     if (e.keyCode === 37) {
  //    // Previous
  //         $(this).find('.js__slider__control-left').click();
  //    return false;
  //     }
  //     if (e.keyCode === 39) {
  //    // Next
  //       $(this).find('.js__slider__control-right').click();
  //    return false;
  //     }
  // });
});

$(window).ready(function () {
  carouselNormalization();
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/carousel.js